import { render, staticRenderFns } from "./irsNews.vue?vue&type=template&id=604bcf1a&scoped=true&"
import script from "./irsNews.vue?vue&type=script&lang=js&"
export * from "./irsNews.vue?vue&type=script&lang=js&"
import style0 from "./irsNews.vue?vue&type=style&index=0&id=604bcf1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bcf1a",
  null
  
)

export default component.exports